import React, { Component } from "react";

import Header from "../components/Header/header";
import HeroSection from "../components/HeroSection//HeroSectionDashboard";

class Dashboard extends Component {
  render() {
    return (
      <React.Fragment>
        <Header />
        <div className="main">
          <HeroSection />
        </div>  
      </React.Fragment>
    );
  }
}

export default Dashboard;
